import '@nackle/icons';
import React, { ReactNode } from 'react';
import './card-header.less';

interface Props {
    className?: string;

    title: ReactNode;

    /**
     * Name of a Blueprint UI icon (or an icon element) to render on the left side.
     */
    icon?: any;

    right?: ReactNode;
}

export function CardHeader({className, icon, right, title, ...rest}: Props) {
    return (
        <div className={`nkl-card-header ${className}`} {...rest}>
            { icon }
            <div className="nkl-card-header-title">{title}</div>
            { right && <div className="nkl-card-header-right">{right}</div> }
        </div>
    );
}
